declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  const f = window
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  b.head.appendChild(t)

  f.fbq('init', '25962343990086349')
  f.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
